'use strict';

function historyFactory(startPage, startPageProps) {
    var startNode = {
        page: startPage,
        props: startPageProps,
        next: undefined,
        prev: undefined
    };

    var length = 1;
    var currentNode = startNode;
    var currentIndex = 0;

    return {
        addPage: function (page, props) {
            var node = {
                page: page,
                props: props || {},
                next: undefined,
                prev: currentNode
            };

            length++;
            if (currentNode) {
                currentNode.next = node;
                this.forward();
            } else {
                currentNode = startNode = node;
            }
        },

        back: function () {
            if (currentNode.prev) {
                currentIndex--;
                currentNode = currentNode.prev;
            }
        },

        forward: function () {
            if (currentNode.next) {
                currentIndex++;
                currentNode = currentNode.next;
            }
        },

        clear: function () {
            currentNode = undefined;
            startNode = undefined;
            length = 0;
            currentIndex = -1;
        },

        getCurrentNode: function () {
            return currentNode;
        },

        getCurrentIndex: function () {
            return currentIndex;
        },

        contains: function (page) {
            var node = currentNode;
            while (node.prev) {
                if (node.page === page) {
                    return true;
                }
                node = node.prev;
            }
            return false;
        }
    };
}

module.exports = historyFactory;



/** WEBPACK FOOTER **
 ** ./public/js/flow/history.js
 **/